/**
 * Check if a user profile has all required fields filled out.
 * A complete profile has displayName and vibeCheck (required).
 * Avatar is encouraged but not required.
 *
 * @param {Object|null} profile - The user's profile object
 * @returns {boolean} - True if profile is complete, false otherwise
 */
export const isProfileComplete = (profile) => {
  if (!profile) return false;
  return !!(profile.displayName && profile.vibeCheck);
};
